export default __webpack_public_path__ + "static/media/icon-down.4b4cf5c5.svg";